import React from 'react';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import SvgIcon from '../../svg-icon';

const NavigationArrowDropDown = React.createClass({

  mixins: [PureRenderMixin],

  render() {
    return (
      <SvgIcon {...this.props}>
        <path d="M7 10l5 5 5-5z"/>
      </SvgIcon>
    );
  }

});

export default NavigationArrowDropDown;



/** WEBPACK FOOTER **
 ** ../src/svg-icons/navigation/arrow-drop-down.jsx
 **/